import React from 'react';
import {Feedback} from "../../types/Feedback";
import Comment from "./Comment";
import Empty from "../Empty";
import {ChatAltIcon} from "@heroicons/react/outline";

// Types ----

type CommentListProps = {
  feedback: Feedback[]
};

// Component ----

function CommentList({feedback}: CommentListProps) {

  // Make sure we only have feedback with comments
  const commentedFeedback = feedback.filter(feedback => !!feedback.comments);

  if(!commentedFeedback.length) {
    return (
      <Empty
        icon={ChatAltIcon}
        text="No comments left"
        hint="As audience members leave feedback, their comments will appear here"
      />
    )
  }
  
  return (
    <ul className="space-y-6">
      {commentedFeedback.map((feedback, index) => (
        <li key={feedback.id} className="relative flex gap-x-4">
          <Comment feedback={feedback} isLast={index === commentedFeedback.length - 1}/>
        </li>
      ))}
    </ul>
  );
}

// Export ----

export default CommentList;